import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { CheckCircle2, Clock } from 'lucide-react';
export function FinalCTASection() {
  const handlePurchaseClick = () => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  const items = ['Material teórico de 1° a 5° año', '+500 actividades didácticas', 'Planificación completa de clases', 'Presentaciones listas para el aula'];
  return <section id="compra" className="bg-[#EDF1F5] py-6 px-4 text-center" data-id="element-71">
      <div className="max-w-xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-lg border border-[#E2DED6] overflow-hidden" data-id="element-73">
          {/* Top banner */}
          <div className="bg-[#4A7C59] text-white py-2 px-4 flex items-center justify-center gap-2" data-id="element-74">
            <Clock size={14} data-id="element-75" />
            <span className="text-xs font-bold uppercase tracking-wide" data-id="element-76">
              Oferta por tiempo limitado
            </span>
            <span className="mx-1" data-id="element-77">•</span>
            <CountdownTimer variant="small" data-id="element-78" />
          </div>

          <div className="p-4 md:p-5" data-id="element-79">
            <h2 className="text-base md:text-lg font-extrabold text-[#424E60] uppercase mb-3" data-id="element-80">
              Todo organizado en un solo lugar
            </h2>

            {/* Summary items - compact grid */}
            <div className="grid grid-cols-2 gap-1.5 mb-4" data-id="element-81">
              {items.map((item, index) => <div key={index} className="flex items-center gap-1.5 bg-[#F4F4F2] rounded-md px-2.5 py-1.5" data-id="element-82">
                  <CheckCircle2 className="text-[#4A7C59] shrink-0" size={14} data-id="element-83" />
                  <span className="text-[#424E60] font-medium text-[11px] leading-tight" data-id="element-84">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* Price */}
            <div className="bg-[#EDF1F5] rounded-xl px-4 py-3 mb-4" data-id="element-85">
              <p className="text-[10px] text-[#586880] font-bold uppercase mb-1" data-id="element-86">
                Colección completa
              </p>
              <div className="flex items-baseline justify-center gap-1.5" data-id="element-87">
                <span className="text-[#586880] line-through text-[16px]" data-id="element-88">
                  $89.990
                </span>
                <span className="font-extrabold text-[#4A7C59] text-[35px]" data-id="element-89">
                  $19.990
                </span>
                <span className="text-xs text-[#586880] font-medium" data-id="element-90">ARS</span>
              </div>
            </div>

            <CTAButton href="https://checkout.ecompradigital.online/cart/46068861173948:1" onClick={handlePurchaseClick} className="!py-3 !text-base" data-id="element-91">
              Acceder a la colección completa
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}